var map = {
	"./CA.json": "1d75",
	"./EN.json": "da8e",
	"./ES.json": "4846",
	"./EU.json": "e2e3",
	"./FR.json": "d054",
	"./GA.json": "cbb1",
	"./PT.json": "5294"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";